import { render, staticRenderFns } from "./SentimentPieChartPNP.vue?vue&type=template&id=79bf4982&"
import script from "./SentimentPieChartPNP.vue?vue&type=script&lang=js&"
export * from "./SentimentPieChartPNP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports